import { render, staticRenderFns } from "./check_standard.vue?vue&type=template&id=a387a082&scoped=true"
import script from "./check_standard.vue?vue&type=script&lang=js"
export * from "./check_standard.vue?vue&type=script&lang=js"
import style0 from "./check_standard.vue?vue&type=style&index=0&id=a387a082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a387a082",
  null
  
)

export default component.exports